"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementType = exports.Element = exports.InlineType = exports.BlockType = exports.TableCellNode = exports.TableNode = void 0;
var Table_1 = require("ContentTokens/Models/Table");
Object.defineProperty(exports, "TableCellNode", { enumerable: true, get: function () { return Table_1.TableCellNode; } });
Object.defineProperty(exports, "TableNode", { enumerable: true, get: function () { return Table_1.TableNode; } });
var Common_1 = require("ContentTokens/Models/Common");
Object.defineProperty(exports, "BlockType", { enumerable: true, get: function () { return Common_1.BlockType; } });
Object.defineProperty(exports, "InlineType", { enumerable: true, get: function () { return Common_1.InlineType; } });
Object.defineProperty(exports, "Element", { enumerable: true, get: function () { return Common_1.Element; } });
Object.defineProperty(exports, "ElementType", { enumerable: true, get: function () { return Common_1.ElementType; } });
